export default "__VITE_ASSET__CDpELbB9__"